import { render } from "./listByTopic.vue?vue&type=template&id=615f5932&scoped=true"
import script from "./listByTopic.vue?vue&type=script&lang=js"
export * from "./listByTopic.vue?vue&type=script&lang=js"

import "./listByTopic.vue?vue&type=style&index=0&id=615f5932&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615f5932"]])

export default __exports__